'use client';

interface Props {
  symbol?: string;
  address?: string;
  label?: string;
}
export default function NetworkAccountLabel({
  symbol,
  address,
  label,
  ...props
}: Props) {
  return label ? (
    <span className="rounded-full bg-gray-100 text-gray-600 text-sm px-2 py-1 whitespace-nowrap">
      {label}
    </span>
  ) : (
    <>-</>
  );
}
